import type { ReactNode } from "react";
import { FswlPublicBrand } from "../../components/BrandLockup";
import { AppThemeToggle } from "../../components/AppThemeToggle";

type AuthShellProps = {
  children: ReactNode;
  title: string;
  subtitle?: string;
  lead?: string;
};

export function AuthShell({ children, title, subtitle, lead }: AuthShellProps) {
  return (
    <div className="auth-layout">
      <header className="auth-layout__toolbar" aria-label="Sign-in options">
        <AppThemeToggle />
      </header>

      <div className="auth-layout__frame">
        <section className="auth-layout__brand" aria-hidden={false}>
          <div className="auth-layout__brand-inner">
            <FswlPublicBrand size="hero" />
            <p className="auth-layout__welcome">Welcome back</p>
            <p className="auth-layout__brand-note">Sign in to continue</p>
          </div>
        </section>

        <section className="auth-layout__main" aria-labelledby="auth-step-title">
          <div className="auth-panel">
            {subtitle ? <p className="auth-panel__subtitle">{subtitle}</p> : null}
            <h1 id="auth-step-title" className="auth-panel__title">
              {title}
            </h1>
            {lead ? <p className="auth-panel__lead">{lead}</p> : null}
            {children}
          </div>
        </section>
      </div>
    </div>
  );
}
